import { Base, Component, Emit, Ref, Watch } from '@/vue-property-decorator'

interface Events {
  onWidth: number
}

@Component<TabTitle>({ name: 'TabTitle' })
export default class TabTitle extends Base<unknown, unknown, Events> {
  @Ref()
  private refTabTitle!: HTMLSpanElement

  private width = 40

  mounted() {
    this.$nextTick(this.getWidth)
    setTimeout(this.getWidth, 60 * 3)
  }

  private getWidth() {
    if (this.refTabTitle?.getBoundingClientRect) {
      this.width = this.refTabTitle?.getBoundingClientRect().width
    }
  }

  @Watch('width', { immediate: true })
  @Emit('width')
  private onWidth() {
    return this.width
  }

  render() {
    return <span ref="refTabTitle">{this.$slots.default}</span>
  }
}
